import React, { memo, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import alert from '@components/alert';

// import TableForm from './tableForm';
import { DragableTableFrom as FormList } from '@components';

import {
  INITIAL_FORM_DATA,
  INITIAL_FORM_DATA_SELL_SIDE,
} from './config/form.config.js';
import {
  getDefaultRowData,
  columns as configColumns,
  defaultColumns as configDefaultColumns,
} from './config/columns.config';
import { addModuleConfig } from './config/add.config';
import { Form } from 'antd';

// import '@style/modules/project/integrationHub/manageForm.scss';
import '../../../../../styles/modules/project/integrationHub/manageForm.scss';

const formLayout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 24 },
};

function ManageMForm(props) {
  const {
    form,
    Action,
    onFinish,
    saveData = {},
    tabKey,
    showSpn,
    columns = configColumns,
    defaultColumns = configDefaultColumns,
    projHomeExtraForm = null,
    multiSectionExtraForm = null,
    pendoField,
    formChange = () => {},
  } = props;
  const location = useLocation();
  // const [actionLoading, toggleActionLoading] = useState(false);
  const [refreshCount, setRefreshCount] = useState(0);
  const cumulateCount = () => {
    setRefreshCount((c) => c + 1);
    formChange();
  };
  const fieldMethods = useRef({});

  const registerFieldsMethods = (methods) => {
    fieldMethods.current = methods;
  };

  const handleSortEnd = ({ newIndex, oldIndex }) => {
    const { move } = fieldMethods.current;
    if (newIndex === 0 || newIndex === 1) {
      return;
    }
    if (move) {
      move(oldIndex, newIndex);
    }
  };

  const scrollYSync = () => {
    setTimeout(() => {
      window.scrollBy({ top: -64 });
    });
  };

  const handleFieldsFail = ({ errorFields, _firstErrorTab, ...rest }) => {
    form.scrollToField(errorFields[0].name, { inline: 'start' });
    scrollYSync();
    alert.warning(errorFields[0].errors[0]);
  };

  const handleSubmitForm = () => {
    form.validateFields().then(onFinish).catch(handleFieldsFail);
  };

  useEffect(() => {
    if (location?.pathname.includes('create') && !saveData.customizeModule) {
      form.setFieldsValue({
        customizeModule:
          saveData?.instanceType !== 'Divestiture'
            ? INITIAL_FORM_DATA
            : INITIAL_FORM_DATA_SELL_SIDE,
      });
    }
  }, []);

  useEffect(() => {
    const oDiv = document.getElementsByClassName(
      'dragable-table-form-header',
    )[0];
    const settingwrapper = document.getElementsByClassName(
      'projects-setting-page-wrapper',
    )[0];
    const formBody =
      settingwrapper &&
      settingwrapper.getElementsByClassName('form-list-body')[0];
    const tabNav =
      settingwrapper &&
      settingwrapper.getElementsByClassName('ant-tabs-nav')[0];
    const formTitle =
      settingwrapper &&
      settingwrapper.getElementsByClassName('project-form-title')[0];

    window.scrollTo(0, 0);

    window.onscroll = function () {
      // 获取当前页面的滚动条纵坐标位置 （依次为火狐谷歌、safari、IE678）
      const scrollT =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;

      // console.log('divT:', divT);
      const isCreatePage = location?.pathname.includes('create');

      if (scrollT > 247 && !isCreatePage && tabKey === 'module') {
        // handleStyle(oDiv);
        if (!oDiv.className.includes('fix-setting-module')) {
          oDiv.className += ' fix-setting-module';
          formTitle.className += ' fixed-form-title';
          tabNav.className += ' fixed-tabs';
          formBody.className += ' mg-formBody';
        }
      } else if (scrollT > 350 && isCreatePage) {
        // handleStyle(oDiv);
        if (!oDiv.className.includes('fix-header')) {
          oDiv.className += ' fix-header';
        }
      } else {
        // oDiv.style.position = '';
        oDiv.className = 'dragable-table-form-row dragable-table-form-header';
        if (tabKey === 'module') {
          tabNav.className = 'ant-tabs-nav';
          formTitle.className = 'project-form-title';
          formBody.className = 'form-list-body';
        }
      }
    };
  }, [tabKey]);

  return (
    <Form
      form={form}
      {...formLayout}
      className="integration-manage-form"
      scrollToFirstError
      autoComplete="off"
      onValuesChange={cumulateCount}
      refreshCount={refreshCount}
    >
      <div className="dragable-table-form ">
        <FormList
          columns={columns}
          registerFieldsMethods={registerFieldsMethods}
          onSortEnd={handleSortEnd}
          isLoading={false}
          key="formlist-customize"
          formInstance={form}
          formChange={formChange}
          name="customizeModule"
          isActive={true}
          getDefaultRowData={getDefaultRowData}
          addBtnText="Add New Module"
          moduleType="manageModule"
          defaultColumns={defaultColumns}
          ratioNeedFullSize={props.ratioNeedFullSize}
          configs={props.configs || { addModuleConfig }}
          showSpn={showSpn}
          projHomeExtraForm={projHomeExtraForm}
          multiSectionExtraForm={multiSectionExtraForm}
          pendoField={pendoField}
        />
      </div>

      {Action && <Action handleSubmitForm={handleSubmitForm} {...props} />}
    </Form>
  );
}

ManageMForm.propTypes = {};

export default memo(ManageMForm);
